import { Pipe } from '@angular/core';

@Pipe({
    name: 'ausAddress'
})
export class AustralianAddressPipe {    
    transform(person: any) {
        if (!person) {
            return null;
        }
        
        let returnValue = '';
        let delimiter = '';        

        if (person.AustralianAddressLine1) {
            returnValue = person.AustralianAddressLine1;
            delimiter = ", ";
        }
        if (person.AustralianAddressLine2) {
            returnValue = returnValue + delimiter + person.AustralianAddressLine2;
            delimiter = ", ";
        }

        if (person.AustralianSuburb) {
            returnValue = returnValue + delimiter + person.AustralianSuburb;
            delimiter = ", ";
        }
        if (person.AustralianState) {
            returnValue = returnValue + delimiter + person.AustralianState;
            delimiter = ", ";
        } 

        if (person.AustralianPostcode) {
            returnValue = returnValue + delimiter + person.AustralianPostcode;
        }

        return returnValue;
    }
}
